// agences-services.ts

export const AGENCES_SERVICES = [
  { label: 'BANQUES', value: 'banque' },
  { label: 'ASSURANCES', value: 'assurances' },
  { label: 'BUREAUX D\'ÉTUDES', value: 'Bureauxdeetudes' },
  { label: 'LEASING', value: 'leasing' },
  { label: 'SERVICES DIVERS', value: 'servicesDivers' },
  { label: 'DÉCORATIONS', value: 'decorations' },
  { label: 'COMMERCES', value: 'Commerces' },
  { label: 'PROFESSIONNELS DE L\'ARTISANAT', value: 'ProDeAartisanat' }
]
;